if (!window.KnyaCarousel) {
class KnyaCarousel {
  constructor(root, options) {
    options = options || {};
    this.root = root;
    this.trackWrap = root.querySelector(options.trackWrapSelector || '[data-carousel-track]');
    this.prevBtn = root.querySelector(options.prevSelector || '[data-carousel-prev]');
    this.nextBtn = root.querySelector(options.nextSelector || '[data-carousel-next]');
    this.dragThreshold = options.dragThreshold || 5;

    if (!this.trackWrap) return;

    this.isDragging = false;
    this.hasMoved = false;
    this.startX = 0;
    this.startScrollLeft = 0;

    this.bindArrows();
    this.bindDrag();
    this.bindState();
  }

  bindState() {
    var self = this;
    var items = this.trackWrap.querySelectorAll('.carousel__item');
    if (!items.length) return;

    var firstItem = items[0];
    var lastItem = items[items.length - 1];
    var firstVisible = true;
    var lastVisible = false;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === firstItem) firstVisible = entry.isIntersecting;
          if (entry.target === lastItem) lastVisible = entry.isIntersecting;
        });
        if (self.prevBtn) self.prevBtn.disabled = firstVisible;
        if (self.nextBtn) self.nextBtn.disabled = lastVisible;
      },
      {root: this.trackWrap, threshold: 0.95}
    );

    observer.observe(firstItem);
    observer.observe(lastItem);
  }

  getItems() {
    return Array.prototype.slice.call(this.trackWrap.querySelectorAll('.carousel__item'));
  }

  currentIndex(items) {
    var scrollLeft = this.trackWrap.scrollLeft;
    var closest = 0;
    var min = Infinity;
    items.forEach(function (item, i) {
      var diff = Math.abs(item.offsetLeft - scrollLeft);
      if (diff < min) {
        min = diff;
        closest = i;
      }
    });
    return closest;
  }

  scrollToIndex(index, items) {
    index = Math.max(0, Math.min(items.length - 1, index));
    this.trackWrap.scrollTo({left: items[index].offsetLeft, behavior: 'smooth'});
  }

  bindArrows() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener(
        'click',
        function () {
          var items = this.getItems();
          this.scrollToIndex(this.currentIndex(items) - 1, items);
        }.bind(this)
      );
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener(
        'click',
        function () {
          var items = this.getItems();
          this.scrollToIndex(this.currentIndex(items) + 1, items);
        }.bind(this)
      );
    }
  }

  bindDrag() {
    var trackWrap = this.trackWrap;

    var onDragStart = function (e) {
      this.isDragging = true;
      this.hasMoved = false;
      this.startX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
      this.startScrollLeft = trackWrap.scrollLeft;
      trackWrap.classList.add('is-dragging');
    }.bind(this);

    var onDragMove = function (e) {
      if (!this.isDragging) return;
      var x = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
      var walk = x - this.startX;
      if (Math.abs(walk) > this.dragThreshold) {
        this.hasMoved = true;
      }
      var maxScroll = trackWrap.scrollWidth - trackWrap.clientWidth;
      var next = this.startScrollLeft - walk;
      trackWrap.scrollLeft = Math.max(0, Math.min(maxScroll, next));
    }.bind(this);

    var onDragEnd = function () {
      this.isDragging = false;
      trackWrap.classList.remove('is-dragging');
    }.bind(this);

    trackWrap.addEventListener('mousedown', onDragStart);
    trackWrap.addEventListener('mousemove', onDragMove);
    trackWrap.addEventListener('mouseup', onDragEnd);
    trackWrap.addEventListener('mouseleave', onDragEnd);

    trackWrap.addEventListener('touchstart', onDragStart, {passive: true});
    trackWrap.addEventListener('touchmove', onDragMove, {passive: true});
    trackWrap.addEventListener('touchend', onDragEnd);

    trackWrap.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    trackWrap.addEventListener(
      'click',
      function (e) {
        if (this.hasMoved) {
          e.preventDefault();
          e.stopPropagation();
        }
      }.bind(this),
      true
    );
  }
}

function initKnyaCarousels(rootSelector, options) {
  document.querySelectorAll(rootSelector).forEach(function (root) {
    if (root.knyaCarouselInitialized) return;
    root.knyaCarouselInitialized = true;
    new KnyaCarousel(root, options);
  });
}

window.KnyaCarousel = KnyaCarousel;
window.initKnyaCarousels = initKnyaCarousels;
}
